import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(1)};
    padding: ${theme.layout.spacing(3)};

    width: 100%;
    max-height: 90vh;

    border-radius: 16px 16px 0 0;
    background: ${theme.palette.neutral[50]};

    header {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(2)};

      h2 {
        font-size: ${theme.typography.sizes.title3};
        font-weight: ${theme.typography.weight.bold};
        color: ${theme.palette.primary.main};
      }

      p {
        font-size: ${theme.typography.sizes.body1};
        font-weight: ${theme.typography.weight.regular};
        color: ${theme.palette.text.light};
      }
    }

    section {
      overflow: auto;

      > div {
        display: flex;
        flex-direction: column;
        gap: ${theme.layout.spacing(2)};
      }
    }

    footer {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(1.5)};

      button {
        width: 100%;
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      max-width: ${theme.layout.spacing(60)};
      border-radius: 16px;

      footer {
        flex-direction: row-reverse;

        button {
          flex: 1;
        }
      }
    }
  `}
`;
